import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ConfirmAccountComponent } from './confirm-account/confirm-account.component';

@NgModule({
	declarations: [ConfirmAccountComponent],
	imports: [SharedModule]
})
export class ConfirmAccountModule {}
